const NotFoundPage = () => {
  return <div>404 Not found!</div>;
};

export default NotFoundPage;
